export const FALLBACK_COLOR = "#94A3B8";

export const jobTypeColor = (jobTypes, name) => (jobTypes || []).find((t) => t.name === name)?.color || FALLBACK_COLOR;

export const textOn = (hex) => {
  const h = (hex || FALLBACK_COLOR).replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? "#0E1E38" : "#FFFFFF";
};

export const jobTypeNames = (jobTypes) => (jobTypes || []).map((t) => t.name);
